<template>
  <div id="servicios" class="services-container">
    <div class="text-center py-4">
      <h2 class="titulo-destacado">SERVICIOS</h2>
    </div>

    <div class="container">
      <div class="row justify-content-center">
        <div 
          v-for="(service, index) in services" 
          :key="index" 
          class="col-md-4 mb-4"
          data-aos="zoom-in-up"
          :data-aos-delay="index * 100"
        >
          <div
            class="service-link"
            @click="goToRoute(index)"
            style="cursor: pointer;"
          >
            <div 
              class="servicio-imagen"
              :class="{ activa: activeCard === index, hover: hoveredCard === index }"
              @mouseover="hoverCard(index)"
              @mouseout="unhoverCard(index)"
            >
              <div 
                class="servicio-background"
                :style="{ backgroundImage: `url('image/${service.image}')` }"
              ></div>
              <div class="servicio-contenido">
                <h3 class="servicio-titulo">{{ service.title }}</h3>
                <p class="servicio-descripcion">{{ service.description }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ServicesSection',
  data() {
    return {
      services: [
        {
          title: "SEGUROS PARA PERSONAS",
          description: "Cada etapa de tu vida merece estar protegida. Elige el respaldo que te acompañe con sentido.",
          image: "personal.jpg",
          route: "/servicio_personal"
        },
        {
          title: "SEGURO PARA BIENES",
          description: "Porque lo material también tiene valor emocional, protégelo siempre con un seguro que te brinde respaldo real y tranquilidad duradera.",
          image: "bienes.jpg",
          route: "/servicio_bienes"
        },

        {
          title: "SEGUROS EMPRESARIALES",
          description: "La protección que tu empresa necesita para seguir creciendo con confianza y estabilidad.",
          image: "empresa.jpg",
          route: "/servicio_empresarial"
        }
      ],
      hoveredCard: null,
      activeCard: null
    };
  },
  methods: {
    hoverCard(index) {
      this.hoveredCard = index;
    },
    unhoverCard(index) {
      if (this.hoveredCard === index) {
        this.hoveredCard = null;
      }
    },
    activateCard(index) {
      this.activeCard = this.activeCard === index ? null : index;
    },
    goToRoute(index) {
      this.activateCard(index); // activa o desactiva la tarjeta
      this.$router.push(this.services[index].route); // navega a la ruta sin recargar
    }
  }
};
</script>

<style scoped>
.services-container {
  background-color: #e0dddd;
  color: #233d72;
  padding-bottom: 4rem;
}

.titulo-destacado {
  color: #233d72;
  font-size: 2.5rem;
  font-weight: bold;
  text-transform: uppercase;
}

.servicio-imagen {
  height: 600px;
  position: relative;
  border-radius: 10px;
  overflow: hidden;
  cursor: pointer;
  transition: box-shadow 0.3s ease;
}

.servicio-imagen.hover .servicio-background,
.servicio-imagen.activa .servicio-background {
  transform: scale(1.1);
}

.servicio-imagen.activa {
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.3);
  z-index: 2;
}

@keyframes slowZoom {
  from {
    transform: scale(1);
  }
  to {
    transform: scale(1.15);
  }
}

.servicio-background {
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  background-size: cover;
  background-position: center;
  z-index: 1;
  transform: scale(1);
  transition: transform 1s ease-in-out;
  filter: brightness(0.6); /* filtro negro */
}

/* Cuando la tarjeta está activa o en hover */
.servicio-imagen.hover .servicio-background,
.servicio-imagen.activa .servicio-background {
  animation: slowZoom 4s ease-in-out forwards;
}

.servicio-contenido {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 20px;
  background: linear-gradient(transparent, rgba(0,0,0,0.7));
  z-index: 2;
  text-align: right; /* alinear texto a la derecha */
}

.servicio-titulo {
  color: white;
  font-weight: bold;
  font-size: 1.6rem;
}

.servicio-descripcion {
  color: #ddd;
  font-size: 1rem;
  line-height: 1.5em;
  height: 3em; /* exactamente dos líneas */
  max-width: 100%; /* asegura que se rompa y no se salga */
  overflow-wrap: break-word;
}


.service-link {
  text-decoration: none;
}

/* ================================
   PARCHE RESPONSIVE
================================ */

/* Evita que textos largos se corten de manera extraña */
.servicio-titulo,
.servicio-descripcion {
  word-break: normal;
  overflow-wrap: normal;
}

/* Tablets y laptops pequeñas */
@media (max-width: 991.98px) {
  .services-container {
    padding-bottom: 3rem;
  }

  .titulo-destacado {
    font-size: 2.1rem;
  }

  .servicio-imagen {
    height: 500px;
  }

  .servicio-contenido {
    padding: 18px;
  }

  .servicio-titulo {
    font-size: 1.4rem;
    line-height: 1.25;
  }

  .servicio-descripcion {
    height: auto;
    min-height: 4.5em;
    font-size: 0.95rem;
    line-height: 1.5;
  }
}

/* Celulares */
@media (max-width: 767.98px) {
  .services-container {
    padding-bottom: 2.5rem;
  }

  .services-container .text-center {
    padding-top: 2rem !important;
    padding-bottom: 1.5rem !important;
  }

  .titulo-destacado {
    margin-bottom: 0;
    font-size: 1.8rem;
  }

  .servicio-imagen {
    width: 100%;
    height: 450px;
  }

  .servicio-contenido {
    padding: 22px 18px;
  }

  .servicio-titulo {
    margin-bottom: 8px;
    font-size: 1.35rem;
    line-height: 1.25;
  }

  .servicio-descripcion {
    height: auto;
    min-height: 0;
    margin-bottom: 0;
    font-size: 0.93rem;
    line-height: 1.5;
  }

  .service-link {
    display: block;
    width: 100%;
  }
}

/* Celulares pequeños */
@media (max-width: 575.98px) {
  .services-container {
    padding-bottom: 2rem;
  }

  .services-container .container {
    padding-left: 16px;
    padding-right: 16px;
  }

  .titulo-destacado {
    font-size: 1.6rem;
  }

  .servicio-imagen {
    height: 400px;
    border-radius: 8px;
  }

  .servicio-contenido {
    padding: 20px 16px;
  }

  .servicio-titulo {
    font-size: 1.2rem;
  }

  .servicio-descripcion {
    font-size: 0.88rem;
    line-height: 1.45;
  }
}

/* Celulares muy pequeños */
@media (max-width: 380px) {
  .servicio-imagen {
    height: 370px;
  }

  .servicio-titulo {
    font-size: 1.1rem;
  }

  .servicio-descripcion {
    font-size: 0.83rem;
  }
}

/* Evita animaciones exageradas en dispositivos táctiles */
@media (hover: none) {
  .servicio-imagen.hover .servicio-background {
    animation: none;
    transform: scale(1);
  }

  .servicio-imagen.activa .servicio-background {
    animation: slowZoom 4s ease-in-out forwards;
  }
}
</style>
